import React, { useState, useEffect, useCallback } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ErrorBoundary from './components/ErrorBoundary';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { setLogoutCallback } from './utils/apiClient';
import './style.css';

function App() {
    const [user, setUser] = useState(() => {
        const saved = localStorage.getItem('axiomus-user');
        return saved ? JSON.parse(saved) : null;
    });

    const [isDarkMode, setIsDarkMode] = useState(() => {
        const saved = localStorage.getItem('axiomus-user');
        if (saved) {
            const u = JSON.parse(saved);
            return u.dark === true || u.dark === 1 || u.dark === '1';
        }
        return false;
    });

    useEffect(() => {
        if (user) {
            localStorage.setItem('axiomus-user', JSON.stringify(user));
            setIsDarkMode(!!user.dark);
        } else {
            localStorage.removeItem('axiomus-user');
            setIsDarkMode(false);
        }
    }, [user]);

    useEffect(() => {
        document.documentElement.classList.toggle('dark', isDarkMode);
    }, [isDarkMode]);

    const handleLogin = (id, name, role, dark, firstName, onboardingCompleted) => {
        setUser({ id, name, first_name: firstName || name.split(' ')[0], role, dark, onboarding_completed: onboardingCompleted });
        setIsDarkMode(!!dark);
    };

    const toggleDarkMode = async () => {
        const next = !isDarkMode;
        setIsDarkMode(next);
        if (user) setUser(prev => ({ ...prev, dark: next }));
    };

    const handleLogout = useCallback(() => {
        setUser(null);
        setIsDarkMode(false);
    }, []);

    const handleProfileUpdate = useCallback((firstName, fullName) => {
        setUser(prev => prev ? { ...prev, first_name: firstName, name: fullName || prev.name } : prev);
    }, []);

    useEffect(() => {
        setLogoutCallback(handleLogout);
    }, [handleLogout]);

    return (
        <BrowserRouter>
            <ErrorBoundary>
                <div className="App">
                    <Routes>
<Route path="/*" element={
                            user
                                ? <Dashboard user={user} onLogout={handleLogout} isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} onProfileUpdate={handleProfileUpdate} />
                                : <Login onLogin={handleLogin} />
                        } />
                    </Routes>
                </div>
            </ErrorBoundary>
        </BrowserRouter>
    );
}

export default App;
